// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import '@/css/element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css'

// import '@/css/element-variables.css'
// import '@/css/pagination.css'
// import '@/css/loading.css'
// import '@/css/radio.css'
// import '@/css/slider.css'
// import '@/css/button.css'
import http from '@/http/index.js'
import processing from '@/mixin/processing.js'
import moment from '@/mixin/moment.js'
import cookie from 'js-cookie'
import toFixed from '@/filter/toFixed.js'
import VisionUI from 'yotta-vue-components/vision-ui-plugin.js'
import echarts from 'echarts/lib/echarts'

import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'

import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'

import 'echarts/lib/component/title'
import saveSystemLog from "@/common/saveLog.js";

Vue.prototype.$echarts = echarts
Vue.use(VisionUI)
Vue.use(ElementUI)
Vue.use(toFixed)
// Vue.use(Antd)
Vue.prototype.$cookie = cookie
Vue.mixin(processing)
Vue.mixin(moment)
Vue.config.productionTip = false
Vue.prototype.$http = http


Vue.prototype.$resourceUrl = 'http://vision-resource.yottasystem.com'
if (window.location.host.indexOf('mumuqing.net') > -1) {
  Vue.prototype.$resourceUrl = 'https://vision-resource.mumuqing.net'
}
Vue.prototype.$trainUrl = 'http://vision-train.yottasystem.com'
if (window.location.host.indexOf('mumuqing.net') > -1) {
  Vue.prototype.$trainUrl = 'https://vision-train.mumuqing.net'
}

Vue.config.errorHandler = function (err, vm, info) {
  let {
    message,
    stack
  } = err
  
  saveSystemLog("error", `错误信息：${stack.slice(0,500)}...；`)
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js